module.exports = __webpack_public_path__ + "img/section-break.2ebaabb8.svg";